import { FullLocaleData } from '@delon/theme';

import ngEn from '@angular/common/locales/en';
import ngPt from '@angular/common/locales/pt';

import { en_US, pt_BR} from 'ng-zorro-antd';

import * as df_en from 'date-fns/locale/en';
import * as df_pt from 'date-fns/locale/pt';

import { en_US as delonEnUS } from '@delon/theme';
import { LangData } from './i18n.lang-data.model';

const delonPtBr: FullLocaleData = {
  abbr: 'pt-BR',
  exception: {
    403: 'Ops, você não tem acesso à esta página',
    404: 'Ops, a página que você está procurando não existe',
    500: 'Ops, ocorreu um erro inesperado na aplicação, avise nossos técnicos para resolvermos',
    backToHome: 'Voltar para página inicial'
  },
  noticeIcon: {
    emptyText: 'Sem registros',
    clearText: 'Limpar'
  },
  reuseTab: {
    close: 'Fechar aba',
    closeOther: 'Fechar as outras abas',
    closeRight: 'Fechar as abas à direita',
    clear: 'Limpar abas'
  },
  tagSelect: {
    expand: 'Expandir',
    collapse: 'Minimizar'
  },
  miniProgress: {
    target: 'Alvo: '
  },
  st: {
    total: '{{range[0]}} - {{range[1]}} de {{total}}'
  },
  sf: {
    submit: 'Enviar',
    reset: 'Limpar',
    search: 'Buscar',
    edit: 'Salvar',
    addText: 'Incluir',
    removeText: 'Excluir',
    checkAllText: 'Marcar todos'
  }
};

export const DEFAULT_LANGUAGE = 'pt-BR';

export const DEFAULT_LANGUAGE_CONFIG =  {
  abbr: 'pt-BR',
  text: 'Português',
  ng: ngPt,
  zorro: pt_BR,
  dateFns: df_pt,
  delon: delonPtBr,
  img: '/assets/img/flag-brazil.png',
};

export const LANGS: { [key: string]: LangData } = {
  en: {
    text: 'English',
    ng: ngEn,
    zorro: en_US,
    dateFns: df_en,
    delon: delonEnUS,
    img: '/assets/img/flag-usa.png',
  },
  'pt-BR': DEFAULT_LANGUAGE_CONFIG,
};
